<template>
    <header>
        <nav @close-menu.stop="toggleMenu()"
             class="flex h-20 fixed top-0 left-0 right-0 shadow-md px-10 lg:px-20 xl:px-32"
             id="mainNav">
            <div class="h-full">
                <img alt=""
                     class="inline-block mt-6 md:mt-5 xl:mt-4 h-8 md:h-10 xl:h-12 cursor-pointer"
                     src="../assets/img/pareliLogo/pareli_logo_black.png"
                     v-on:click.stop="navigateTo(null)"
                >
            </div>

            <div class="flex-grow"></div>

            <div class="flex flex-row items-center float-right leading-loose">

                <div @click.stop="toggleMenu()"
                     class="hamburger flex flex-col justify-between xl:hidden cursor-pointer">
                    <div class="line" v-bind:class="{hamburger_x1: isOpen}"></div>
                    <div class="line" v-bind:class="{hamburger_x2: isOpen}"></div>
                    <div class="line" v-bind:class="{hamburger_x3: isOpen}"></div>
                </div>
                <div v-if="!hamburgerOn"
                     class="xl:flex flex-row items-center flex-no-wrap"
                >
                    <MenuItem :active-key="activeKey"
                              :itemKey="itemKey"
                              :key="itemKey"
                              :title="title"
                              v-for="(title, itemKey) in navigation"
                              v-on:navigate-to="navigateTo"
                    />

                    <LanguageSelect @set-language="setLanguage"/>
                </div>
            </div>
        </nav>
        <div v-if="hamburgerOn"
             id="menu"
             class="flex flex-col justify-center items-center"
             :class="{menu_open: isOpen}"
        >
            <MenuItem :active-key="activeKey"
                      :itemKey="itemKey"
                      :key="itemKey"
                      :title="title"
                      class="menu_item"
                      v-for="(title, itemKey) in navigation"
                      v-on:navigate-to="navigateTo"
            />

            <LanguageList @set-language="setLanguage"/>
        </div>
    </header>
</template>

<script>
import LanguageList from '@/components/baseComponents/LanguageList';
import LanguageSelect from '@/components/baseComponents/LanguageSelect';
import MenuItem from './baseComponents/MenuItem';

export default {
    name: 'MenuHeader',
    components: {LanguageList, LanguageSelect, MenuItem},
    props: [
        'activeKey',
        'navigation',
    ],
    data() {
        return {
            isOpen: false,
            hamburgerOn: parseInt(window.innerWidth) < 1280,
        };
    },
    created() {
        window.onresize = () => {
            this.hamburgerOn = window.innerWidth < 1280;

            if (!this.hamburgerOn)
                this.isOpen = false;
        };
    },
    methods: {
        navigateTo(event) {
            this.$emit('navigate-to', event);
            this.toggleMenu(false);
        },
        toggleMenu(isOpen = null) {
            this.isOpen = isOpen !== null ? isOpen : !this.isOpen;

            let children = $('#menu').children();
            setTimeout(() => {
                children.each(child => {
                    setTimeout(
                        () => {
                            switch (isOpen) {
                                case null:
                                    children[child].classList.toggle('swiftLeft');
                                    break;

                                case true:
                                    children[child].classList.add('swiftLeft');
                                    break;

                                case false:
                                    children[child].classList.remove('swiftLeft');
                                    break;
                            }
                        }, 100 * child);
                });
            }, 300);

            this.$emit('toggle', this.isOpen);
        },
        setLanguage(language) {
            this.$emit('set-language', language);
        },
    },
};
</script>

<style scoped>
#mainNav {
    background: #fff;
    z-index: 30;

}

.hamburger {
    height: 30%;
    width: 50px;
}

.line {
    width: 100%;
    height: 15%;
    background-color: black;
    transition: all 0.2s ease-in-out;
}

.hamburger_x1 {
    transform: rotate(45deg) translate(13px, 3px);
}

.hamburger_x2 {
    width: 0;
    margin: auto;
    opacity: 0;
}

.hamburger_x3 {
    transform: rotate(-45deg) translate(10px, -2px);
}

.menu_item {
    transform: translateX(20px);
    transition: all 0.2s ease-in-out;
    opacity: 0;
}

.swiftLeft {
    opacity: 1;
    transform: translateX(0px);
}

@media (max-width: 1280px) {
    #menu {
        position: fixed;
        top: 0px;
        right: -121vw;
        height: 100vh;
        width: 50vw;
        padding-top: 80px;
        background-color: #fff;
        z-index: 25;
        box-shadow: -8px 0px 15px rgba(0, 0, 0, 0.5);
        transition: transform 0.6s ease-in-out;
    }

    .menu_open {
        transform: translateX(-120vw);
    }

}

@media (max-width: 800px) {
    #menu {
        width: 70vw;
        right: -121vw;
    }
}

@media (max-width: 600px) {
    #menu {
        width: 100vw;
        right: -120vw;
    }
}
</style>
